export function resolvePostAuthPath(next: string | null | undefined): string {
  if (!next) return '/onboarding/create-org';

  try {
    const decoded = decodeURIComponent(next);
    if (!decoded.startsWith('/') || decoded.startsWith('//')) return '/onboarding/create-org';
    return decoded;
  } catch {
    return '/onboarding/create-org';
  }
}

export function googleSignInCallbackPath(origin: string, next: string | null | undefined): string {
  const path = next && next !== '/' ? next : '/staff/setup';
  return `${origin}${path}`;
}

export function appendFlowFlag(path: string, key: string, value = '1'): string {
  const [pathname, hash = ''] = path.split('#', 2);
  const separator = pathname.includes('?') ? '&' : '?';
  const withQuery = `${pathname}${separator}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  return hash ? `${withQuery}#${hash}` : withQuery;
}
